export const color = {
  background: {
    dark: "#0f0f11", // slightly richer black, less flat
    mid: "#1a1a1e", // for cards/sections on dark bg
    light: "#fbfbfb", // warm white, easier on eyes than pure
    subtle: "#fef9f9", // warm light gray for alternating sections
    red: "#f5e8e8", // kept close, slightly warmer tint
  },
  text: {
    heading: "#0D0C0A", // warm near-black, less harsh than pure black
    neutral: "#1E2340", // slightly deeper navy for better contrast
    body: "#4a4f63", // for paragraph text, softer than neutral
    secondary: "#747474", // slightly cooler, more refined muted tone
    primary: "#ad2d26", // brand red — unchanged
    primaryHover: "#c43330", // for hover states on red elements
    inverse: "#F8F7F5", // matches light bg for text on dark surfaces
  },
  border: {
    light: "#d0cbc8", // warm border for light sections
    dark: "#a5a5a5", // subtle border for dark sections
    red: "#c9817d",
    subtle: "#e2e8f0", // light border for cards
  },
  surface: {
    dark: "#16161a", // card bg on dark pages
    light: "#FFFFFF", // card bg on light pages
    red: "#fbe9e9", // soft red tint surface
  },
  default: {
    white: "#ffffff",
    black: "#000000",
  },
};
